export const siteMetadata = {
  title: 'Javascript Cheatsheet',
  description:
    'Anyone can forget how to make character classes for a regex, slice a list or do a for loop. This cheat sheet tries to provide a basic reference for beginner and advanced developers, lower the entry barrier for newcomers and help veterans refresh the old tricks.',
  keywords: [
    'javascript',
    'js',
    'cheatsheet',
    'cheat sheet',
    'functions',
    'arrays',
    'array methods',
    'objects',
    'maps',
    'sets',
    'strings',
    'regex',
    'regular expressions',
    'json',
    'promises',
    'async await',
    'modules',
    'dom',
    'events',
    'fetch',
    'debugging',
    'error handling',
    'control flow',
    'browser',
    'node',
  ],
  image: '/social/social_banner.png',
  baseUrl: import.meta.env.VITE_BASE_URL || 'http://localhost:3000',
}
